import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { TableModule } from 'primeng/table'
import { SharedModule } from '../shared/shared.module'
import { AutoCompleteModule } from 'primeng/autocomplete'
import { InputTextModule } from 'primeng/inputtext'
import { ButtonModule } from 'primeng/button'
import { DialogModule } from 'primeng/dialog'
import { CheckboxModule } from 'primeng/checkbox'
import { TreeSelectModule } from 'primeng/treeselect'
import { TooltipModule } from 'primeng/tooltip'
import { ScrollingModule } from '@angular/cdk/scrolling'
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling'
import { OverlayPanelModule } from 'primeng/overlaypanel'
import { SelectButtonModule } from 'primeng/selectbutton'
import { InputNumberModule } from 'primeng/inputnumber'
import { MatSortModule } from '@angular/material/sort'
import { MatIconModule } from '@angular/material/icon'
import { MatTableModule } from '@angular/material/table'
import { MatGridListModule } from '@angular/material/grid-list'
import { MatRadioModule } from '@angular/material/radio'
import { BrowserModule } from '@angular/platform-browser'
import { ProgressBarModule } from 'primeng/progressbar'
import { MatStepperModule } from '@angular/material/stepper'
import { NgApexchartsModule } from 'ng-apexcharts'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { EntraSyncAppComponent } from './entra-sync-app.component'
import { SelectModule } from 'primeng/select'
import { IconFieldModule } from 'primeng/iconfield'
import { InputIconModule } from 'primeng/inputicon'

@NgModule({
   declarations: [EntraSyncAppComponent],
   imports: [
      CommonModule,
      SharedModule,
      FormsModule,
      ReactiveFormsModule,
      AutoCompleteModule,
      ButtonModule,
      CheckboxModule,
      DialogModule,
      SelectModule,
      IconFieldModule,
      InputIconModule,
      InputTextModule,
      TableModule,
      TreeSelectModule,
      TooltipModule,
      ScrollingModule,
      CdkVirtualScrollViewport,
      OverlayPanelModule,
      InputNumberModule,
      SelectButtonModule,
      MatSortModule,
      MatIconModule,
      MatTableModule,
      MatGridListModule,
      MatRadioModule,
      BrowserModule,
      ProgressBarModule,
      MatStepperModule,
      NgApexchartsModule,
      BrowserAnimationsModule,
   ],
})
export class EntraSyncModule {}
